// extracted by mini-css-extract-plugin
module.exports = {"blue":"#6387C5","lightBlue":"rgb(207, 216, 231)","smoke":"rgb(186, 191, 189)","brand":"#174E8C","textColor":"#182C3D","errorRed":"rgb(204, 61, 63)"};